import React, { PureComponent } from 'react'
import { connect } from 'redaction'
import { compose } from 'helpers'

import s from './GisMeteoWidget.scss'


class GisMeteoWidget extends PureComponent {

  componentDidMount() {
    this.init()
  }

  componentDidUpdate({ weatherCode }) {
    const { weatherCode: newWeatherCode } = this.props
    
    if (!weatherCode && newWeatherCode) {
      this.init()
    }
  }

  init = () => {
    const { weatherCode } = this.props

    if (weatherCode && weatherCode.script) {
      const weatherScript = document.createElement('script')

      weatherScript.src    = weatherCode.script
      weatherScript.async  = true

      document.body.appendChild(weatherScript)
    }
  }

  render() {
    const { weatherCode } = this.props

    return Boolean(weatherCode && weatherCode.html) && (
      <div
        className={s.weatherCodeWidget}
        dangerouslySetInnerHTML={{ __html: weatherCode.html }}
      />
    )
  }
}


export default compose(
  connect({
    weatherCode: 'ui.weatherCode',
  }),
)(GisMeteoWidget)
